define('Balance.Model',
  [
    'Backbone.Model',
    'Utils'
  ],
  function
  (
    BackboneModel,
    Utils
  ) {
    'use strict';
    
    return BackboneModel.extend({
      urlRoot: Utils.getAbsoluteUrl('extensions/MHI/MHI_Durastone_Extension/1.0.0/services/Balance.Service.ss')
    });
  });
